@use '@fukuri-admins/ui/layout' as *;

.cardListContainer {
  display: flex;
  flex-direction: column;
  gap: 1px;
  background-color: $NATURAL_100;
  margin-bottom: 1px;
}

.card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 10px 8px;
  gap: 18px;
}

.cardLeft {
  display: flex;
  align-items: center;
  gap: 8px
}

.cardRight {
  display: flex;
  align-items: center;
  gap: 8px
}

.cancelled {
  color: text('Red');
}

.uncancelled {
  color: text('Teal');
}

.cardColumn {
  display: flex;
  flex-direction: column;
}

.cardValue {
  font-size: 14px;
  color: $NATURAL_500;
  word-break: break-all;
}

.cardBranch {
  font-size: 14px;
  font-weight: 500;
  color: text('Middle')
}

.cardIssueIdentity {
  font-size: 12px;
  color: text('Disabled');
}

.cardAmount {
  font-size: 16px;
  font-weight: 600;
}

.cancelButton {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 4px;

  &:disabled {
    cursor: not-allowed;
  }
}

.cancelButton:hover {
  text-decoration: underline;
}

.modalContent {
  padding: 40px;
  background-color: white;
  border-radius: 8px;
  max-width: 650px;
  width: 90%;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  .modalTitle {
    text-align: center;
    font-size: 28px;
    padding: 10px;
  }

  .modalDescription {
    margin-bottom: 8px;
    color: #767779;
  }

  .errorMessage {
    color: red;
    font-family: "Noto Sans JP";
    font-weight: 800;
    font-size: 14px;
    line-height: 22px;
    text-align: left;
  }

  .btnContainer {
    margin-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
}

